import { DefaultDetailContext } from 'src/app/controls/forms/default-detail-context';
import { IParams } from 'src/app/models/interfaces/params.interface';

export class ParametersDetailContext extends DefaultDetailContext<IParams, number> {}
